import React from 'react';
import styled, { keyframes } from 'styled-components/macro';

const pulse = keyframes`
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(1);
  }
  40% {
    opacity: 1;
    transform: scale(1.3);
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
`;

const Dot = styled.div<{ delay: string }>`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  animation: ${pulse} 1.4s infinite ease-in-out;
  animation-delay: ${({ delay }) => delay};
  background-color: ${props => props.theme.colors.primary[100]};
`;

interface IThreeDotPulseProps {
  extendStyles?: {
    container?: React.CSSProperties;
    dot?: React.CSSProperties;
  };
}

export const ThreeDotPulse = ({ extendStyles }: IThreeDotPulseProps) => (
  <LoadingContainer style={extendStyles?.container}>
    <Dot delay='0s' style={extendStyles?.dot} />
    <Dot delay='0.2s' style={extendStyles?.dot} />
    <Dot delay='0.4s' style={extendStyles?.dot} />
  </LoadingContainer>
);
